<ion-content class="modal-container">
  <div class="modal-header">
    <h2>Descarga de Certificado de Saldos</h2>
    <ion-icon name="close-outline" role="button" (click)="cerrar()" (keypress)="keyPressClose($event)" tabindex="0"
      aria-label="Cerrar"></ion-icon>
    <div *ngIf="isResponsive">
      <app-descarga-certificado-stepper></app-descarga-certificado-stepper>
    </div>
  </div>


  <div class="modal-body" [class.no-footer]="pasoActual === 2 || pasoActual === 3">
    <div class="stepper" *ngIf="!isResponsive">
      <app-descarga-certificado-stepper></app-descarga-certificado-stepper>
    </div>

    <div class="content">

      <ng-container [ngSwitch]="pasoActual">

        <div *ngSwitchCase="1">
          <h3>Por favor, lee y acepta la declaración para descargar el certificado</h3>
          <ul>
            <li>Descargar el Certificado de Saldos no significa que estés aceptando la información que allí se detalla,
              ya que solo es una instancia informativa de tus ahorros.</li>
            <li>
              Solo estarás aceptando la información del Certificado de Saldos, el cual sirve para realizar la
              solicitud de ofertas SCOMP. Cuando lo hagas, se entenderá que no tienes observaciones sobre el mismo.</li>
          </ul>
          <ion-item lines="none" class="check-legal" [class.check-legal-footer]="!esCopiaCertificado">
            <ion-checkbox slot="start" [(ngModel)]="aceptaDeclaracion" [disabled]="esCopiaCertificado"></ion-checkbox>
            <ion-label>He leído y acepto lo anterior declarado</ion-label>

          </ion-item>
          <p *ngIf="esCopiaCertificado" class="check-legal-info-aviso">
            La declaración fue aceptada previamente.
          </p>

          <h3>Consideraciones</h3>
          <ul>
            <li>Solo podrás obtener tu certificado si cuentas con tus datos actualizados y Clave de Seguridad.</li>
            <li>
              Puedes revisar tu información registrada y actualizarla en <a class="link" (click)="goToPerfil()">Tus
                datos.</a>
            </li>
          </ul>

          <div class="details-datos-personales">
            <div class="detail-item ">
              <span>Télefono:</span>
              <span>{{ (datosPersonales.telefono | formatPhoneNumber) || 'Aún no registras tu teléfono'}}</span>
            </div>
            <div class="detail-item ">
              <span>Correo:</span>
              <span>{{ datosPersonales.email }}</span>
            </div>
          </div>
        </div>

        <div *ngSwitchCase="2">
          <ng-template #microfrontContainer></ng-template>
        </div>


        <div *ngSwitchCase="3" class="details-descarga-certificado">
          <div *ngIf="!errorServiceDescargaCertificado">
            <h3>Descarga tu Certificado de Saldos</h3>

            <ul>
              <li>Te enviaremos una copia del certificado a tu correo registrado.
              </li>
              <li>
                Al descargar tu Certificado de Saldos <strong>comunícate con nosotros para solicitar la oferta de
                  pensión.</strong>
                Contáctanos antes de la fecha de vencimiento del documento, <strong>de lo contrario, tu trámite se
                  cerrará.</strong>
              </li>
            </ul>

            <div class="details-datos-personales">
              <div class="detail-item ">
                <span>Correo:</span>
                <span>{{ datosPersonales.email }}</span>
              </div>
              <div class="detail-item ">
                <span>Vigencia del documento:</span>
                <span>35 días corridos</span>
              </div>
            </div>
          </div>
          <div *ngIf="errorServiceDescargaCertificado" class="errorServiceDescargaCertificado">
            <ion-icon name="alert-circle" class="icon-error"></ion-icon>
            <h3>Lo sentimos, ocurrió un error al descargar tu certificado</h3>
            <p>Por favor, reinténtalo o ingresa más tarde</p>

            <div class="details-datos-personales">
              <strong>Para más información</strong>
              <p>Llámanos al <a href="tel:+6006600900">600 6600 900</a> o agenda una <a href="/video-atencion">Video
                  Atención.</a></p>
            </div>
            <div class="buttons-error-service">
              <button (click)="reintentarErrorDescarga()" class="btn-continuar"
                (keydown.enter)="reintentarErrorDescarga()" [disabled]="loading">
                Reintentar <ion-icon name="refresh" *ngIf="!attempt"
                  style="font-size: 20px; margin-left: 5px;"></ion-icon>
                <ion-spinner name="crescent" slot="end" *ngIf="attempt" color="light"></ion-spinner></button>
              <button (click)="onGoToInicioTramite()" class="btn-continuar secondary-button"
                (keydown.enter)="onGoToInicioTramite()" [disabled]="loading">
                Ir a Inicio del trámite
              </button>
            </div>

          </div>
        </div>
        <div *ngSwitchCase="4" class="content-comprobante">

          <ion-icon name="checkmark-circle-sharp" class="icon-check"></ion-icon>
          <h3>Tu certificado fue descargado con éxito</h3>


          <p>Podrás encontrarlo en tu carpeta de Descargas. También lo enviamos a tu correo con la copia adjunta. En
            caso de no encontrarlo en tu bandeja principal, por favor, revisa tu spam.</p>
          
          <p><strong>¿Qué viene ahora?<br>Comunícate con uno de nuestros ejecutivos a través de una <a href="/video-atencion">video
                  atención</a> o llamando al
              <a href="tel:+6006600900">600 6600 900</a></strong> para solicitar la oferta de pensión o en caso de tener dudas con la información
            entregada. Esto debes hacerlo antes de la fecha de vencimiento del documento, de lo contrario tu trámite se
            cerrará.
          </p>

          <div class="details-datos-personales">
            <div class="detail-item ">
              <span>Documento:</span>
              <span>Certificado de Saldo</span>
            </div>
            <div class="detail-item ">
              <span>Fecha:</span>
              <span>{{ fechaDescargaCertificado | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="detail-item ">
              <span>Enviado a:</span>
              <span>{{ datosPersonales.email }}</span>
            </div>
          </div>         
        </div>

      </ng-container>
    </div>
  </div>

  <div class="modal-footer" *ngIf="pasoActual !== 2 && pasoActual !== 3">
    <ion-button (click)="avanzar()" [disabled]="pasoActual === 1 && !aceptaDeclaracion" class="btn-continuar"
      (keydown.enter)="avanzar()">
      {{ pasoActual < pasos.length ? 'Continuar' : 'Volver al inicio del Trámite' }} </ion-button>
  </div>
  <div class="modal-footer" *ngIf="pasoActual === 3 && !errorServiceDescargaCertificado">
    <ion-button (click)="descargarCertificado()" class="btn-continuar"
      (keydown.enter)="descargarCertificado()" [disabled]="loading">
      Descargar Certificado <ion-spinner name="crescent" slot="end" *ngIf="loading"
        color="light"></ion-spinner></ion-button>
  </div>

</ion-content>